module.exports = "/static/assets/cc0065f74161f7e7859b31796aaa3345.svg";